import React from 'react';
import { Button, Space, Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import { googleMapsUrl, hasGpsCoordinates } from '../utils/map-url';

const { Text } = Typography;

interface GpsLocationProps {
  latitude?: number;
  longitude?: number;
  /** 'cell' = table column (compact "Map" link); 'field' = detail page ("Open in Google Maps"). */
  variant?: 'cell' | 'field';
  /** Rendered when no GPS — defaults to an em dash. Pass null to render nothing. */
  empty?: React.ReactNode;
}

/**
 * Copyable lat/lng text plus a Google Maps deep link.
 * Shared by the food-logs and workout-logs resources.
 */
export function GpsLocation({
  latitude,
  longitude,
  variant = 'field',
  empty = <Text type="secondary">—</Text>,
}: GpsLocationProps) {
  // hasGpsCoordinates narrows only its first parameter — check longitude too.
  if (!hasGpsCoordinates(latitude, longitude) || typeof longitude !== 'number') {
    return <>{empty}</>;
  }
  const coords = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
  return (
    <Space direction="vertical" size={2}>
      <Text copyable={{ text: coords }} style={variant === 'cell' ? { fontSize: 12 } : undefined}>
        {coords}
      </Text>
      <Button
        type="link"
        size="small"
        icon={<EnvironmentOutlined />}
        href={googleMapsUrl(latitude, longitude)}
        target="_blank"
        rel="noopener noreferrer"
        style={variant === 'field' ? { padding: 0, height: 'auto' } : undefined}
      >
        {variant === 'field' ? 'Open in Google Maps' : 'Map'}
      </Button>
    </Space>
  );
}
